import React, { useEffect } from 'react';
import Modal from 'react-modal';
import '../../styles/modals/ConfirmationFeedDeleteModal.css';
import { ReactComponent as ConfirmImage } from '../../assets/svg/ConfirmImage.svg';
import Loading from '../Loading';

interface ConfirmationModalProps {
	modalIsOpen: boolean;
	closeModal: () => void;
	confirmation: () => Promise<void> | void;
	message: string;
	subMessage?: string;
	loading?: boolean;
}

function ConfirmationModal({ modalIsOpen, closeModal, confirmation, message, subMessage = '', loading = false }: ConfirmationModalProps) {
	useEffect(() => {
		const element = document.getElementById('home');

		Modal.setAppElement('#root');

		if (modalIsOpen) {
			if (element) element.style.filter = 'blur(5px)';
		} else {
			if (element) element.style.filter = 'unset';
		}

		return () => {
			if (element) element.style.filter = 'unset';
		};
	}, [modalIsOpen]);

	return (
		<Modal
			isOpen={modalIsOpen}
			onRequestClose={loading ? undefined : closeModal}
			contentLabel='Confirmation Modal'
			style={{
				overlay: {
					zIndex: 10,
					background: '#00000045',
				},
				content: {
					width: 600,
					height: 450,
					padding: 0,
					minWidth: 600,
					margin: 'auto',
					marginTop: '2%',
					backgroundColor: 'transparent',
					maxHeight: '90%',
					border: 'none',
					boxShadow: 'none',
					overflow: 'hidden',
				},
			}}
		>
			<div className='bg-white rounded-xl flex flex-col h-full items-center justify-between p-10'>
				<ConfirmImage />

				<div className='text-center'>
					<p className='text-primaryViolet text-xl font-bold'>{message}</p>
					{subMessage && <p className='text-mudPurple text-sm mt-2'>{subMessage}</p>}
				</div>

				<div className='flex flex-row justify-between items-center w-full mt-6 gap-4'>
					<button
						disabled={loading}
						onClick={closeModal}
						className={`border border-solid border-mudPurple flex items-center justify-center font-bold rounded-xl w-[250px] h-[55px] transition
							${loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-mudPurple hover:text-white text-mudPurple'}
						`}
					>
						Cancel
					</button>

					<button
						disabled={loading}
						onClick={confirmation}
						className={`border border-solid border-redError flex items-center justify-center font-bold rounded-xl w-[250px] h-[55px] transition
							${loading ? 'cursor-not-allowed bg-redError' : 'hover:bg-redError text-redError hover:text-white'}
						`}
						style={{ borderWidth: 1, borderColor: 'red' }}
					>
						{loading ? <Loading primaryColor='#ffffff' secondaryColor='#ffffff' size={22} /> : 'Delete'}
					</button>
				</div>
			</div>
		</Modal>
	);
}

export default ConfirmationModal;
